import React, { useEffect, useState } from "react";
import "./HighScores.css";
import { useFirebase } from "../contexts/FirebaseContext";
import { useLanguage } from "../contexts/LanguageContext";

const MazeHighScores = ({ currentTimeSec, currentMoves, inline = true }) => {
  const { getMazeHighScores, userId } = useFirebase();
  const { t } = useLanguage();
  const [scores, setScores] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      try {
        const list = await getMazeHighScores(10);
        setScores(list.slice(0, 10));
      } catch (e) {
        console.error(e);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [getMazeHighScores]);

  const containerClass = inline ? "high-scores-inline" : "high-scores-container";
  const cardClass = inline
    ? "high-scores-card high-scores-inline-card"
    : "high-scores-card";

  const formatTime = (sec) =>
    typeof sec === "number" ? `${sec.toFixed(1)}s` : "";

  return (
    <div className={containerClass}>
      <div className={cardClass}>
        <h2 className="high-scores-title">🏁 {t("highScores")}</h2>

        {currentTimeSec != null && (
          <div className="current-score-display">
            <p className="current-score-label">{t("yourScore")}</p>
            <p className="current-score-value">{formatTime(currentTimeSec)}</p>
            <p className="current-score-rank">
              {t("moves")}: {currentMoves}
            </p>
          </div>
        )}

        {loading ? (
          <div className="high-scores-loading">{t("loading")}</div>
        ) : scores.length === 0 ? (
          <div className="high-scores-empty">{t("noHighScores")}</div>
        ) : (
          <div className="high-scores-list">
            {scores.map((s, index) => (
              <div
                key={s.id}
                className={`high-score-item ${
                  s.userId && userId && s.userId === userId
                    ? "current-user-score"
                    : ""
                }`}
              >
                <div className="high-score-rank">#{index + 1}</div>
                <div className="high-score-name">{s.displayName || t("anonymous")}</div>
                <div className="high-score-value">
                  {formatTime(s.timeSec)} · {t("moves")} {s.moves ?? "—"}
                </div>
                <div className="high-score-date">
                  {s.timestamp?.toDate
                    ? s.timestamp.toDate().toLocaleDateString()
                    : ""}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default MazeHighScores;


